import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Box,
  CardContent,
  CardHeader,
  List,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import PageTransition from "./PageTransition";
import SimpleLoadingOverlay from "./SimpleLoadingOverlay";
import { useWaiverSubmitState } from "./WaiverSubmitProvider";

export default function WaiverSubmitList() {
  const {
    token,
    waiver_id,
    sharing,
    setSharing,
    item,
    setItem,
    hasMoreWaivers,
    pages,
    setPages,
    handleLoadSuccess,
    handleLoadError,
    submit,
    loading,
  } = useWaiverSubmitState();

  return (
    <Box sx={{ position: "relative", minHeight: "300px" }}>
      <SimpleLoadingOverlay open={loading} />
      {!loading && (
        <PageTransition direction={-1}>
          <CardHeader
            title={sharing?.name}
            subheader={sharing?.location_label}
          />
          <CardContent>
            <List>
              {sharing?.waivers.map(waiver => {
                return (
                  <ListItemButton
                    key={waiver.id}
                    divider
                    component={Link}
                    to={`${waiver.id}`}
                  >
                    <ListItemText
                      sx={{ pr: 2 }}
                      primary={waiver.name}
                      secondary={waiver.description}
                      //onClick={() => setItem(waiver)}
                    />
                    <ListItemSecondaryAction>
                      <ChevronRightIcon />
                    </ListItemSecondaryAction>
                  </ListItemButton>
                );
              })}
            </List>
          </CardContent>
        </PageTransition>
      )}
    </Box>
  );
}
